import { ca } from '@cian/analytics';

export function trackClick(label: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'card',
    action: 'send_message',
    label,
    useLastProducts: true,
  });
}
